var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('a',{attrs:{"href":"javascript:void(0);"}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mdi mdi-content-copy",class:_vm.copied ? 'text-success' : '',attrs:{"title":_vm.title},on:{"click":function($event){return _vm.copyToClipboard(_vm.text)}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }